const rootElement = document.querySelector('#hp-lp-pdp-product')
const { variantIdsByColor } = JSON.parse(rootElement.dataset.params) 
const seasonalIncomeValueElement = rootElement.querySelector('[data-selector="seasonal-income-value"]')

const displaySeasonalIncome = () => {
  const DEVICES = {
    'maxi-pro': {
      th: 60,
      wh: 1500,
    },
    maxi: {
      th: 39,
      wh: 1500,
    },
    trio: {
      th: 10,
      wh: 1500,
    },
    canvas: {
      th: 10,
      wh: 400,
    }
  }  

  fetch('https://api.heatbit.com/api/v2.0/currency/rates')
  .then((res) => res.json())
  .then((data) => {
    const { btcPrice, hashValue } = data.body
    const day = 30.5
    const selectedDevice = DEVICES[seasonalIncomeValueElement.dataset.device]
    const th = selectedDevice.th
    const deviceNumber = 1
    const monthNumber = 6
      
    const incomeUsd = Math.round(btcPrice * hashValue * th * day * monthNumber * deviceNumber)
    seasonalIncomeValueElement.dataset.seasonalIncome = incomeUsd
    seasonalIncomeValueElement.innerText = incomeUsd

    const seasonalIncomePlaceholderElement = rootElement.querySelector('[data-selector="seasonal-income-placeholder"]')
    seasonalIncomePlaceholderElement.classList.add('tw:hidden')
    const seasonalIncomeElement = rootElement.querySelector('[data-selector="seasonal-income"]')
    seasonalIncomeElement.classList.remove('tw:hidden')    
  })
  .catch((error) => {
    console.error('An error has occured while enabling profit calculator')
  });
}

if (seasonalIncomeValueElement) displaySeasonalIncome()

const initGalleryAndDescriptionSections = () => {
  const galleryContainerElements = Array.from(rootElement.querySelectorAll('[data-selector="gallery-container"]'))
  galleryContainerElements
    .forEach(galleryContainerElement => {
      const swiperElement = galleryContainerElement.querySelector('[data-selector="swiper"]')
      const nextButtonElement = galleryContainerElement.querySelector('[data-selector="next-button"]')
      const prevButtonElement = galleryContainerElement.querySelector('[data-selector="prev-button"]')
      const previewButtonElements = Array.from(galleryContainerElement.querySelectorAll('[data-selector="preview-button"'))
  
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
          nextEl: nextButtonElement,
          prevEl: prevButtonElement
        },
        on: {
          slideChange: (swiper) => {
            const activeIndex = swiper.realIndex
            previewButtonElements.forEach(previewButtonElement => previewButtonElement.dataset.active = false)
            previewButtonElements[activeIndex].dataset.active = true
          }
        }
      })
  
      previewButtonElements.forEach(
        (previewButtonElement, index) => previewButtonElement
          .addEventListener('click', () => {
            swiper.slideTo(index)
          }
      ))
    })

  // Initialize bundle & add to cart buttons  
  const descriptionContainerElements = Array.from(rootElement.querySelectorAll('[data-selector="description-container"]'))
  descriptionContainerElements
    .forEach(descriptionContainerElement => {
      const { variantId } = descriptionContainerElement.dataset
      let quantitySelected = 1
      
      const bundleButtonElements = Array.from(descriptionContainerElement.querySelectorAll('[data-selector="bundle-button"]'))
      bundleButtonElements.forEach((bundleButtonElement, index) => bundleButtonElement.addEventListener('click', () => {
        bundleButtonElements.forEach(bundleButtonElement => bundleButtonElement.dataset.active = false)
        bundleButtonElement.dataset.active = true
        quantitySelected = index + 1
      }))
  
      const addToCartButtonElement = descriptionContainerElement.querySelector('[data-selector="add-to-cart-button"]')
      addToCartButtonElement.addEventListener('click', () => {
        addToCartButtonElement.innerText = "Adding..."
      
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json', 
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId, 
                quantity: quantitySelected,
                //selling_plan: sellingPlan,
                properties: {
                  // "Order type": "",
                  // "Estimated shipping": "4-6 weeks"
                }
              }
            ]
          })
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Error adding to cart');
            }
            return response.json(); 
          })
          .then(data => {
            addToCartButtonElement.innerText = "Add to cart"
            // {% comment %} addToCartMobileButton.innerText = "Add to cart" {% endcomment %}
            try {
              openIACartDrawer();
            } catch {}
          })
          .catch(error => {
            console.error('Error:', error);
          }); 
      })
    })
  
  // Initialize color buttons
  const colorButtonElements = Array.from(rootElement.querySelectorAll('[data-selector="color-button"]'))
  colorButtonElements.forEach((colorButtonElement) => colorButtonElement.addEventListener('click', () => {
    const { variantId } = colorButtonElement.dataset
  
    colorButtonElements
      .forEach(colorButtonElement => 
        colorButtonElement.dataset.active = colorButtonElement.dataset.variantId === variantId
      )
    descriptionContainerElements
      .forEach(descriptionContainerElements => 
        descriptionContainerElements.dataset.active = descriptionContainerElements.dataset.variantId === variantId
      )
    galleryContainerElements
      .forEach(galleryContainerElements => 
        galleryContainerElements.dataset.active = galleryContainerElements.dataset.variantId === variantId
      )
    }))
}


const initializeVideoReviewsSection = () => {
  const sectionElement = rootElement.querySelector('[data-selector="video-reviews-section"]')
  const swiperElement = sectionElement.querySelector('[data-selector="swiper"]')
  const nextButtonElement = sectionElement.querySelector('[data-selector="next-button"]')
  const prevButtonElement = sectionElement.querySelector('[data-selector="prev-button"]')

  const swiper = new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: true,
    navigation: {
      nextEl: nextButtonElement,
      prevEl: prevButtonElement
    },
    breakpoints: {
      768: { 
        slidesPerView: 3
      }
    },
    on: {
      slideChange: () => {
        Array.from(swiperElement.querySelectorAll('video')).forEach(videoElement => {
          videoElement.pause()
          videoElement.currentTime = 0
        })
      }
    }
  })

  const playButtonElements = Array.from(sectionElement.querySelectorAll('[data-selector="play-button"]'))
  playButtonElements.forEach(button => {
    button.addEventListener('click', () => {
      const videoUrl = button.dataset.videoUrl;
      const videoType = button.dataset.videoType;
      const container = button.closest('.swiper-slide');

      if (!videoUrl || !container) return;

      const video = document.createElement('video');
      video.className =
        'tw:absolute tw:inset-0 tw:w-full tw:h-full tw:object-cover tw:rounded-[1rem]';

      video.controls = true;
      video.autoplay = true;
      video.muted = false;
      video.playsInline = true;

      const source = document.createElement('source');
      source.src = videoUrl;
      source.type = videoType || 'video/webm';

      video.appendChild(source);
      container.appendChild(video);

      const player = new Plyr(video, {
        controls: ['play-large', 'play', 'mute'],  // Keep 'mute' so user can toggle
        loop: { active: true },
        autoplay: true,     // Important: include this explicitly
        muted: false,        // Start muted to allow autoplay
        volume: 1           // Full volume ready for unmuting
      });

      // Unmute as soon as playback begins (safe because of the click gesture)
      player.once('play', () => {  // 'once' to do it only the first time
        player.muted = false;
      });

      // Fallback: if 'play' doesn't fire reliably, also try on 'playing'
      player.on('playing', () => {
        if (player.muted) {
          player.muted = false;
        }
      });

      button.remove();
    });
  });
}


const initializeQuotesSection = () => {
  const sectionElement = rootElement.querySelector('[data-selector="quotes-section"]')
  const swiperElement = sectionElement.querySelector('[data-selector="swiper"]')
  const nextButtonElement = sectionElement.querySelector('[data-selector="next-button"]')
  const prevButtonElement = sectionElement.querySelector('[data-selector="prev-button"]')

  const swiper = new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: nextButtonElement,
      prevEl: prevButtonElement
    }
  })
}


const initializeSetupSection = () => {
  const sectionElement = rootElement.querySelector('[data-selector="setup-section"]')
  const swiperElement = sectionElement.querySelector('[data-selector="swiper"]')
  const nextButtonElement = sectionElement.querySelector('[data-selector="next-button"]')
  const prevButtonElement = sectionElement.querySelector('[data-selector="prev-button"]')
  const currentSlideElement = sectionElement.querySelector('[data-selector="current-slide"]')
  
  new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: nextButtonElement,
      prevEl: prevButtonElement
    },
    on: {
      slideChange: (swiper) => {
        const activeIndex = swiper.realIndex
        currentSlideElement.innerText = activeIndex + 1
      }
    }
  })
}


initGalleryAndDescriptionSections()
initializeVideoReviewsSection()
initializeSetupSection()
initializeQuotesSection()
